// extracted by mini-css-extract-plugin
export default {"widgetIcon":"isI7xiu","container":"AYL96eR","medium":"JpgornA","small":"y15UUgT"};